export const SERVER_API_SISMART = "https://apisekolah.sismart.id/v1prod/"

// let SERVER_APIURL = 'https://apitestoss.sismart.id/';

// let SERVER_APIURL = 'https://apiv2.sismart.id/';

let SERVER_APIURL = '';

if(localStorage.SECOLAH_CODE === 'devel'){
    //sismart dev
    SERVER_APIURL  = "https://apistaging.sismart.id/";
}else{
    // sismart prod
    SERVER_APIURL  = "https://apisismart.sismart.id/";
}

export const SERVER_API  = SERVER_APIURL;
export const SERVER_OSSF  = 'https://storages.sismart.id/apisismart/';
export const SERVER_FILE = SERVER_OSSF+ localStorage.SECOLAH_CODE + "/apischool/";

export const MEDIA_HOST          = SERVER_FILE + "public/files/";
export const FOTO_WALI_HOST      = SERVER_FILE + "public/images/wali/";
export const FOTO_SISWA_HOST     = SERVER_FILE + "public/images/siswa/";
export const FOTO_EVENT_HOST     = SERVER_FILE + "public/images/event/";
export const FOTO_CONTENT_HOST   = SERVER_FILE + "public/images/konten/";
export const FOTO_PRESENSI_HOST  = SERVER_FILE + "public/images/presensi/";
export const FOTO_SISWA_APP_HOST = SERVER_FILE + "public/images/identity/siswa/";



// WEBPACK FOOTER //
// ./src/constants/siteConfig.js